import styled from 'styled-components';

const MOBILE = '@media (max-width: 768px)';

export const HeroWrap = styled.div`
  position: relative;
  overflow: hidden;
  background: ${({ theme }) =>
    `linear-gradient(180deg, ${theme.colors.accentBgSoft} 0%, ${theme.colors.accentLight}33 35%, transparent 80%)`};

  &::before {
    content: '';
    position: absolute;
    top: -20%;
    right: -10%;
    width: 50rem;
    height: 50rem;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.accentLight};
    opacity: 0.4;
    filter: blur(8rem);
    pointer-events: none;
  }
`;

export const Hero = styled.section`
  max-width: 110rem;
  margin: 0 auto;
  padding: ${({ theme }) => `6.4rem ${theme.spacing.lg} 4.8rem`};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
  position: relative;
  z-index: 1;

  ${MOBILE} {
    grid-template-columns: 1fr;
    text-align: center;
    padding: ${({ theme }) => `2.4rem ${theme.spacing.lg} 3.2rem`};
    gap: 2.4rem;
  }
`;

export const HeroLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${MOBILE} {
    align-items: center;
    text-align: center;
  }
`;

export const HeroRight = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: stretch;

  ${MOBILE} {
    flex-direction: column;
    align-items: center;
  }
`;


export const HeroFormHeading = styled.h2`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  margin: 0 0 0.4rem;
`;

export const HeroFormSub = styled.p`
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.5;
  margin: 0 0 ${({ theme }) => theme.spacing.lg};
`;

export const HeroHeading = styled.h1`
  font-size: 4.6rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.darkSlate};
  line-height: 1.1;
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  letter-spacing: -0.1rem;

  ${MOBILE} {
    font-size: 3rem;
  }
`;

export const HeroAccent = styled.span`
  color: ${({ theme }) => theme.colors.accent};
`;

export const HeroSub = styled.p`
  font-size: 1.7rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  line-height: 1.6;
  max-width: 48rem;
  margin: 0 0 ${({ theme }) => theme.spacing.xxl};

  ${MOBILE} {
    max-width: 54rem;
    margin: 0 auto ${({ theme }) => theme.spacing.xxl};
  }
`;

export const WaitlistCard = styled.div`
  width: 100%;
  max-width: 48rem;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 2rem;
  padding: ${({ theme }) => theme.spacing.xxl};
  border: 0.1rem solid ${({ theme }) => theme.colors.border};
  text-align: left;
  box-shadow: 0 1.6rem 4rem rgba(15, 23, 42, 0.08);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 0.4rem;
    background: ${({ theme }) =>
      `linear-gradient(90deg, ${theme.colors.accent} 0%, ${theme.colors.accentDark} 100%)`};
  }

  @media (max-width: 768px) {
    padding: ${({ theme }) => theme.spacing.xl};
    max-width: none;
  }
`;

export const WaitlistButton = styled.button`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.md};
  background-color: ${({ theme }) => theme.colors.accent};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: 1.2rem;
  font-size: 1.5rem;
  font-weight: 700;
  cursor: pointer;
  margin-top: ${({ theme }) => theme.spacing.sm};
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const WaitlistSuccess = styled.p`
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.accent};
  font-weight: 600;
  text-align: center;
  padding: ${({ theme }) => `${theme.spacing.xl} 0`};
`;

export const WaitlistError = styled.p`
  color: ${({ theme }) => theme.colors.errorRed};
  font-size: 1.3rem;
  margin-top: ${({ theme }) => theme.spacing.sm};
  text-align: center;
`;




export const HeroSubAccent = styled.strong`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.accentDark};
`;

export const FormReassure = styled.p`
  margin: ${({ theme }) => theme.spacing.sm} 0 0;
  font-size: 1.2rem;
  font-weight: 600;
  text-align: center;
  color: ${({ theme }) => theme.colors.slateGrey};
`;
